<template>
    <div class="container">
        <base-button v-if="!source" type="link" class="cert-canvas" :style="{ outline: 0, outlineOffset: 0 }" @click="generate">
            <div class="label">
                <i class="el-icon-refresh-right"></i>
                <div class="generate-text">Click here to <em>Generate</em></div>
            </div>
        </base-button>

        <div v-else class="d-flex justify-content-start cert-canvas-display">
            <img class="p-2 image" :src="source" height="180" width="300" />
        </div>

        <div class="row d-flex justify-content-end mt-4">
            <base-button size="md" :disabled="isPartnerAccount && hasSignature!=0" variant="warning" @click.native="clear">Clear</base-button>

            <base-button size="md" variant="primary" @click.native="apply">Apply</base-button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: "alert-signature-certificate",

    props: ['drawData', 'hasSignature', 'isPartnerAccount'],
    data: function () {
        return {
            source: ""
        };
    },
    methods: {
        load() {
            this.source = this.drawData;
        },
        generate() {
            //generate the CAC Signature
            this.$loaderApp.addRequest();

            this.axios.get("/api/signatures/certificate").then((response) => {
                //Load the data
                const signature = "data:image/jpg;base64," + response.data;
                this.source = signature;
                this.$loaderApp.completeRequest();
            })
        
            .catch((err) => {
                this.$toast.error("Error on generating the signature, Please try again later");
                this.$loaderApp.completeRequest();
            
            });
        },

        clear() {
            this.source = "";
        },
        apply: function () {
            this.$emit('onCertResult', { edit: this.source, view: this.source });
        },
    },
}
</script>

<style scopped>
.cert-canvas, .cert-canvas-display {
    background-color: #fff;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.cert-canvas:hover {
    border-color: #409EFF !important;
}

.cert-canvas .label .el-icon-refresh-right {
    font-size: 67px;
    color: #C0C4CC;
    margin: 40px 0 16px;
    line-height: 50px;
}

.cert-canvas .label .generate-text {
    color: #606266;
    font-size: 14px;
    text-align: center;
}

.cert-canvas .label .generate-text em {
    color: #409EFF;
    font-style: normal;
}
</style>
